import { MlbSportId } from '../enums/mlb-stats-api/base.enum';
import { PlayerLevel } from '../enums/pitches.enums';

export class MlbHelper {
  static getLevelFromSportId(sportId: MlbSportId): PlayerLevel {
    switch (sportId) {
      case MlbSportId.SingleA: {
        return PlayerLevel.SingleA;
      }

      case MlbSportId.HighA: {
        return PlayerLevel.HighA;
      }

      case MlbSportId.AA: {
        return PlayerLevel.AA;
      }

      case MlbSportId.MLB: {
        return PlayerLevel.Pro;
      }

      case MlbSportId.AAA: {
        return PlayerLevel.AAA;
      }

      case MlbSportId.Rookie:
      default: {
        return PlayerLevel.Rookie;
      }
    }
  }

  // defines sorting in descending level of play (i.e. MLB has lowest index, rookie has highest index)
  static getSportIdSort(sportId: MlbSportId) {
    switch (sportId) {
      case MlbSportId.MLB: {
        return 0;
      }
      case MlbSportId.AAA: {
        return 1;
      }
      case MlbSportId.AA: {
        return 2;
      }
      case MlbSportId.HighA: {
        return 3;
      }
      case MlbSportId.SingleA: {
        return 4;
      }
      case MlbSportId.Rookie: {
        return 5;
      }
      default: {
        return 100;
      }
    }
  }
}
